










import Vue from 'vue';
import { ISocialMedia } from '../../../../common/interfaces/frontpage.interface';
import TIcons from '../../../../types/TIcons';

export default Vue.extend({
  name: `SocialMediaLink`,
  computed: {
    socialMediaIcon(): string {
      return TIcons.frontpage.socialMedia[this.socialMedia.type];
    },
  },
  props: {
    socialMedia: {
      required: true,
      type: Object as () => ISocialMedia,
    },
  },
});
